<template>
  <fb-list-body :pager="pager" :showSearchForm="false" :showBtnGroup="true"
                @handlePagerSizeChange="handlePagerSizeChange" @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="btn-group">
      <el-button icon="el-icon-plus" @click="$router.push('/tag-add')">{{ $t('lang.新增') }}</el-button>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{ $t('lang.删除') }}</el-button>
    </template>


    <template slot="table" style="border: 10px solid #ccc">

      <el-table :data="tableData" @selection-change="handleSelectionChange" @row-dblclick="handleEdit">

        <el-table-column type="selection" width="50"></el-table-column>

<!--        <el-table-column prop="number" :label="$t('lang.编号')"></el-table-column>-->
        <el-table-column prop="name" :label="$t('lang.标签名称')"></el-table-column>
        <el-table-column prop="recipeTagNumber" :label="$t('lang.编号')"></el-table-column>
        <el-table-column prop="recipeCount" :label="$t('lang.菜谱数量')"></el-table-column>
        <el-table-column prop="recipeTagNumber" :label="$t('lang.是否在机器显示')">
          <template v-slot="{row}">
            {{row.show === "Y" ? $t('lang.是') : $t('lang.否')}}
          </template>
        </el-table-column>
        <el-table-column>
          <template v-slot="{row}">
            <nation-list disabled :list="row.langs | formatLangList" :high-light="row.langs | formatLangList" />
          </template>
        </el-table-column>

        <el-table-column fixed="right" :label="$t('lang.操作')" width="280">
          <template slot-scope="scope">
            <el-button size="mini" @click='$router.push({path: "/tag-edit",query: {code: scope.row.recipeTagCode} });' plain  type="primary">
              {{$t('lang.编辑')}}
            </el-button>
            <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">
              {{$t('lang.删除')}}
            </el-button>
          </template>
        </el-table-column>


      </el-table>
    </template>


  </fb-list-body>
</template>

<script>
import NationList from "../../components/nation/NationList";
export default {
  name: "TagList",
  components: {NationList},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime()
      }
    },
  },
  data() {
    return {
      api: {
        list: this.$api.recipeTag.list,
        delete: this.$api.recipeTag.delete,
        batchDelete: this.$api.recipeTag.batchDelete,
      },
      searchForm: {},
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      time: '',

    }
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    }
  },
  watch: {
    timestamp() {
      this.handleSearch();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch();

      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {

        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch();

      },
      deep: true
    }

  },
  methods: {

    handleEdit(e) {

      if (e && e.code) {
        this.$router.push({
          path: 'edit',
          query: {
            code: e.code
          }
        });
        return;
      }

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.未选择记录')
        });
        return;
      }

      if (this.selection.length > 1) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.一次只能编辑一条数据')
        });
        return;
      }

      this.$router.push({
        path: 'edit',
        query: {
          code: this.selection[0].code
        }
      });
    },
    handleDelete(row) {
      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(vm.api.delete, vm.$qs.stringify({
          code: row.recipeTagCode
        })).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleSearch();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });

    },
    handleBatchDelete() {
      let vm = this;

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }


      let codes = [];
      this.selection.forEach((e) => {
        codes.push(e.recipeTagCode);
      });

      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(this.api.batchDelete, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleSearch();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });


    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleSearch() {
      let vm = this;
      let data = {
        brandOwnerCode: JSON.parse(sessionStorage.getItem("login-user-info")).brandOwnerCode,
        ...this.searchParams
      }
      this.$http.post(this.api.list, this.$qs.stringify(data)).then((resp) => {

        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }

        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;

      })
    }
  },
  created() {

    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  },
  filters: {
    formatLangList(langs) {
      if(!langs) return [];
      return langs.split(',');
    }
  }
}
</script>

<style scoped>

</style>
